//import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history'

export default createBrowserHistory({
  basename: process.env.NODE_ENV === 'development' ? '' : ''
});